// © Microsoft Corporation. All rights reserved.

import { attr } from "@microsoft/fast-element";
import { Anchor } from "@microsoft/fast-foundation";

export class NavItem extends Anchor {
    @attr({ mode: "boolean" })
    public active = false;
}